<app-alert></app-alert>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong id="pageTitle">Register of Documents Executed under Common Seal</strong>
    </span>
    <span style="float: right">
      <!-- <a routerLink="/documentundercommonseallist"> -->
        <button (click)="back()" class="btn btn-sm btn-default pull-right btn-back" type="button">
          <i class=" fa fa-chevron-circle-left"></i>
          Back
        </button>
      <!-- </a> -->
    </span>

    <!-- <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button"
        [disabled]="!(commonSealForm.valid)">
        <span> <i class="fa fa-save"></i>Generate Output </span>
      </button>
</span> -->
  </div>
  <div class="card-block">
    <form [formGroup]='commonSealForm' (document:click)="a.close();b.close()">
      <div class="row">
        <div class="form-group col-md-6 col-sm-6 col-xs-12">
          <label>Description of Documents</label>
          <span _ngcontent-c2="" style="color: red;">*</span>
          <input type="text" class="form-control" [formControl]="commonSealForm.controls['descriptionOfDocumemts']"
            maxlength="200" ng-model="fact.desc.en">
          <div
            *ngIf="commonSealForm.controls['descriptionOfDocumemts'].hasError('required') && commonSealForm.controls['descriptionOfDocumemts'].touched"
            class="form-control-error-custom">
            Description of Documents required
          </div>
        </div>

        <div class="form-group  col-md-6 col-sm-6 col-xs-12">
          <label>Date of the resolution authorising the use of common seal</label>
          <span _ngcontent-c2="" style="color: red;">*</span>

          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [maxDate]="TodayDate"
              [formControl]="commonSealForm.controls['dateOfResolutionauthorisingtheuseofcommonseal']"
              [(ngModel)]="dateOfResolutionauthorisingtheuseofcommonseal" style="padding:6px;z-index: 0;"
              placeholder="dd-mm-yyyy" name="dateOfResolutionauthorisingtheuseofcommonseal" ngbDatepicker
              #a="ngbDatepicker" (click)="a.toggle()">
            <button class="input-group-addon" (click)="a.toggle()">
              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
            </button>
          </div>
          <div
            *ngIf="commonSealForm.controls['dateOfResolutionauthorisingtheuseofcommonseal'].hasError('required') && commonSealForm.controls['dateOfResolutionauthorisingtheuseofcommonseal'].touched"
            class="form-control-error-custom">
            Date of the resolution authorising the use of common seal required
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group  col-md-6 col-sm-6 col-xs-12">
          <label>Date of affixing seal on the document</label>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [maxDate]="TodayDate"
              [formControl]="commonSealForm.controls['dateOfaffixixngsealonthedocument']"
              [(ngModel)]="dateOfaffixixngsealonthedocument" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
              name="dateofaffixixngsealonthedocument" ngbDatepicker #b="ngbDatepicker" (click)="b.toggle()">
            <button class="input-group-addon" (click)="b.toggle()" type="button">
              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span> </button>
          </div>
        </div>
        <div class="form-group col-md-6 col-sm-6 col-xs-12">
          <label>Name of person(s) who attested the affixation</label>
          <input type="text" class="form-control" [formControl]="commonSealForm.controls.nameOfPerson">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6 col-sm-6 col-xs-12">
          <label>Place at which documents was so sealed</label>
          <input type="text" class="form-control" [formControl]="commonSealForm.controls.place">
        </div>

        <div class="form-group col-md-6 col-sm-6 col-xs-12">
          <label>Remarks, if any</label>
          <textarea class="form-control" [formControl]="commonSealForm.controls.remarks" maxlength="200"
            ng-model="fact.desc.en"></textarea>
        </div>

      </div>


    </form>
  </div>
  <div class="card-footer">
    <div class="form-group" align="right" *ngIf="!addBtn">
      <button class="btn btn-sm btn-primary" (click)="saveCommonSealData()" type="button"
        [disabled]="!(commonSealForm.valid) || disabledOnclick">
        <span> <i class="fa fa-save"></i>&nbsp;Save </span> </button>
    </div>
    <div class="form-group" align="right" *ngIf="addBtn">
        <!-- <button class="btn btn-sm btn-primary" (click)="generateOutput(editsealId._id)" type="button"
        [disabled]="!(commonSealForm.valid)">
        <span> <i class="fa fa-save"></i>Generate Output </span>
      </button> -->
      <button class="btn btn-sm btn-primary" (click)="updateCommonSeal(editsealId._id)" type="button"
        [disabled]="!(commonSealForm.valid) || disabledOnclick">
        <span> <i class="fa fa-save"></i>&nbsp;Update </span>
      </button>
    </div>
  </div>
</section>